import React from 'react';
import { NetInfo } from 'react-native'
import { colors, global } from "../../const";

const checkConnection = async () => {
    let isConnected = await NetInfo.isConnected.fetch();
    return isConnected;
}
export default checkConnection;
